var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 1.0 "),_c('el-input',{model:{value:(_vm.test),callback:function ($$v) {_vm.test=$$v},expression:"test"}}),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.testFD}},[_vm._v("确 定")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }